import React from 'react';
import styles from './Tabel.module.scss';
import { Table } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, priceFenToYuanCell } from '@/components/TableCell';
import { regFenToYuan } from '@/util/money';

class TableContent extends React.Component {


    _columns = () => [
        {
            title: '结算单号',
            dataIndex: 'id',
            key: 'id',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '变化金额',
            dataIndex: 'changeBalance',
            key: 'changeBalance',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: priceFenToYuanCell
        },
        {
            title: '账户余额',
            dataIndex: 'remainBalance',
            key: 'remainBalance',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: priceFenToYuanCell
        },
        {
            title: '类型',
            dataIndex: 'appChangeValue',
            key: 'appChangeValue',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '变动时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑手姓名',
            dataIndex: 'riderName',
            key: 'riderName',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '手机号',
            dataIndex: 'riderTel',
            key: 'riderTel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '业务单号',
            dataIndex: 'bizId',
            key: 'bizId',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        }
    ];

    _takeDataSource = (data) => {
        if (data && Array.isArray(data)) {
            return data.map((item) => {
                if (item.changeType == 'PUNISHMENT') {
                    item.jfm = '-' + regFenToYuan(item.fines); // 惩罚金额
                    item.jfs = '-' + item.serviceScore; // 惩罚服务分
                    item.jfl = '-' + item.levelScore; // 惩罚等级分
                } else if (item.changeType == 'REWARD') {
                    item.jfm = '+' + regFenToYuan(item.fines); // 奖励金额
                    item.jfs = '+' + item.serviceScore; // 惩罚服务分
                    item.jfl = '+' + item.levelScore; // 惩罚等级分
                } else {
                    item.jfm = regFenToYuan(item.fines);
                    item.jfs = item.serviceScore;
                    item.jfl = item.levelScore;
                }
                return item;
            });
        } else {
            return [];
        }
    }

    render() {
        const { paginationChange, selectedRowKeys } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.flexBoxContainer}>
                <div className={styles.tableContainer}>
                    <Table
                        rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                        rowKey={(record, index) => index}
                        columns={this._columns()}
                        dataSource={this._takeDataSource(dataList)}
                        pagination={false}
                        scroll={{ y: true }}
                    />
                    <XPagination
                        resultTotal={resultTotal}
                        pageSize={pageSize}
                        pageNum={pageNum}
                        onChange={paginationChange}
                    />
                </div>
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default TableContent;

